export enum WIDGET_LEGACY_POST_LIST {
    SHARED_WITH = 'FRONT.COMMUNITY.POST.SHARED_WITH',
}
